export default __webpack_public_path__ + "static/media/FormModel.ca238651.png";